/* tslint:disable */
/* eslint-disable */
/**
 * Risks API
 * API for managing risks.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * État de la fiche médicale complémentaire (formalités médicales) côté process.
 * 
 * @export
 * @interface BorrowerMedicalFormProcessDto
 */
export interface BorrowerMedicalFormProcessDto {
    /**
     * Vrai dès que le courtier a déclenché l'envoi de l'email au souscripteur.
     * @type {boolean}
     * @memberof BorrowerMedicalFormProcessDto
     */
    isSend: boolean;
    /**
     * Vrai dès que le back a reçu au moins un document uploadé via le lien public.
     * @type {boolean}
     * @memberof BorrowerMedicalFormProcessDto
     */
    isReceived: boolean;
    /**
     * Nombre de documents reçus (uploadés par le souscripteur).
     * @type {number}
     * @memberof BorrowerMedicalFormProcessDto
     */
    resultsCount: number;
    /**
     * Date d'envoi de l'email au souscripteur. Null tant que isSend === false.
     * @type {Date}
     * @memberof BorrowerMedicalFormProcessDto
     */
    sendDate?: Date | null;
    /**
     * Date de la confirmation finale du dépôt par le souscripteur.
     * Null tant que isReceived === false.
     * 
     * @type {Date}
     * @memberof BorrowerMedicalFormProcessDto
     */
    receivedDate?: Date | null;
    /**
     * Vrai si le souscripteur a échoué 3 fois la saisie DDN. Il faut regénérer un nouveau lien.
     * 
     * @type {boolean}
     * @memberof BorrowerMedicalFormProcessDto
     */
    isBlocked?: boolean;
    /**
     * Vrai si plus de 30 jours se sont écoulés sans confirmation du dépôt. Il faut regénérer un nouveau lien.
     * 
     * @type {boolean}
     * @memberof BorrowerMedicalFormProcessDto
     */
    isExpired?: boolean;
}

/**
 * Check if a given object implements the BorrowerMedicalFormProcessDto interface.
 */
export function instanceOfBorrowerMedicalFormProcessDto(value: object): value is BorrowerMedicalFormProcessDto {
    if (!('isSend' in value) || value['isSend'] === undefined) return false;
    if (!('isReceived' in value) || value['isReceived'] === undefined) return false;
    if (!('resultsCount' in value) || value['resultsCount'] === undefined) return false;
    return true;
}

export function BorrowerMedicalFormProcessDtoFromJSON(json: any): BorrowerMedicalFormProcessDto {
    return BorrowerMedicalFormProcessDtoFromJSONTyped(json, false);
}

export function BorrowerMedicalFormProcessDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BorrowerMedicalFormProcessDto {
    if (json == null) {
        return json;
    }
    return {
        
        'isSend': json['isSend'],
        'isReceived': json['isReceived'],
        'resultsCount': json['resultsCount'],
        'sendDate': json['sendDate'] == null ? undefined : (new Date(json['sendDate'])),
        'receivedDate': json['receivedDate'] == null ? undefined : (new Date(json['receivedDate'])),
        'isBlocked': json['isBlocked'] == null ? undefined : json['isBlocked'],
        'isExpired': json['isExpired'] == null ? undefined : json['isExpired'],
    };
}

export function BorrowerMedicalFormProcessDtoToJSON(json: any): BorrowerMedicalFormProcessDto {
    return BorrowerMedicalFormProcessDtoToJSONTyped(json, false);
}

export function BorrowerMedicalFormProcessDtoToJSONTyped(value?: BorrowerMedicalFormProcessDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'isSend': value['isSend'],
        'isReceived': value['isReceived'],
        'resultsCount': value['resultsCount'],
        'sendDate': value['sendDate'] == null ? undefined : ((value['sendDate'] as any).toISOString()),
        'receivedDate': value['receivedDate'] == null ? undefined : ((value['receivedDate'] as any).toISOString()),
        'isBlocked': value['isBlocked'],
        'isExpired': value['isExpired'],
    };
}

